"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_kb_api_1 = require("@synisys/skynet-store-kb-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var kb_utilities_1 = require("../kb.utilities");
function serializeGroup(category) {
    return lodash_1.mapValues(category, function (value, key) {
        if (key === skynet_store_kb_api_1.ENTITY_MULTILINGUAL_NAME_ATTRIBUTE) {
            return skynet_store_utilities_1.serializeMultilingualString(value);
        }
        return value;
    });
}
exports.serializeGroup = serializeGroup;
function deserializeGroups(values) {
    return immutable_1.List(values).map(createGroup);
}
exports.deserializeGroups = deserializeGroups;
function createGroup(value) {
    var group = (lodash_1.mapValues(value, function (it, key) {
        if (key === skynet_store_kb_api_1.ENTITY_MULTILINGUAL_NAME_ATTRIBUTE) {
            return skynet_store_utilities_1.deserializeMultilingual(it);
        }
        return skynet_store_utilities_1.deserializeIfMultilingual(it);
    }));
    return kb_utilities_1.makeValueObject(group, function (first, other) {
        return kb_utilities_1.toLower(first.systemName) === kb_utilities_1.toLower(other.systemName) &&
            kb_utilities_1.toLower(first.metaCategoryId.systemName) ===
                kb_utilities_1.toLower(other.metaCategoryId.systemName);
    }, function (obj) { return immutable_1.hash(obj.systemName) * 31 + immutable_1.hash(obj.metaCategoryId.systemName); });
}
exports.createGroup = createGroup;
//# sourceMappingURL=group.serializer.js.map